import EditCard from "./EditCard";

export default EditCard;
